import { Link } from 'react-router-dom';

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/9aa69218a04b27dfbbca68cacfb5a286.jpeg"
                alt="Premium chai in an elegant gold-rimmed cup"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-8 w-32 h-32 md:w-40 md:h-40 rounded-lg overflow-hidden shadow-lg border-4 border-background-50">
              <img
                src="https://static.readdy.ai/image/207d1fdbe5520f856773b12bb4c3bbee/2adbff2abb5784cde77892932d115f1e.jpeg"
                alt="Samosa and chai pairing"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:pl-4">
            <p className="text-primary-500 font-label text-sm tracking-[0.15em] uppercase mb-3">
              Our Story
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mb-6">
              The Heart Behind
              <br />
              <span className="text-primary-500">Ghalib Chai</span>
            </h2>
            <div className="space-y-4 text-foreground-700 text-base leading-relaxed mb-8">
              <p>
                Ghalib Chai was born from a simple dream — to bring people
                together over a cup of authentic, lovingly prepared chai. Named
                after the legendary poet Mirza Ghalib, our space embodies the
                warmth of tradition and the elegance of timeless hospitality.
              </p>
              <p>
                We source the finest tea leaves directly from Afghanistan and
                the Kashmir region, ensuring every brew carries the richness of
                its origin. Our signature Karak Chai is brewed fresh throughout
                the day, using a blend of cardamom, cinnamon, and fresh milk
                that has been perfected over years.
              </p>
              <p>
                Whether you are here for a quick morning cup, a leisurely
                afternoon with friends, or to take home our premium green tea
                packs — every visit to Ghalib Chai is an invitation to slow
                down and savor the moment.
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-primary-600 font-medium hover:text-primary-700 transition-colors group"
            >
              Discover More About Us
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}